import ValidacionMovil from './ValidacionMovil';

export default ValidacionMovil;
